export default __webpack_public_path__ + "static/media/empty.f809f50a.svg";